// src/components/modals/FlagModal.jsx
import React, { Component } from 'react';

class FlagModal extends Component {
    render() {
        const {
            show,
            station,
            verified_by,
            remarks,
            onClose,
            onVerifiedByChange,
            onRemarkChange,
            onAddIssue,
            onSubmit,
            isSubmitDisabled,
            formatTimestamp
        } = this.props;

        if (!show) return null;

        return (
            <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(2px)" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0" style={{ borderRadius: "12px", display: "flex", flexDirection: "column", maxHeight: "90vh" }}>
                        <div className="modal-header border-0" style={{ background: "#193e6c", color: "white", borderRadius: "12px 12px 0 0" }}>
                            <h5 className="modal-title">
                                Raise Flag for {station}
                            </h5>
                            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                        </div>

                        <div className="modal-body py-4" style={{ overflowY: "auto", flex: "1 1 auto" }}>
                            <div className="d-flex">
                                <div className="mb-3 w-50">
                                    <label className="form-label text-muted">Date</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        disabled
                                        value={formatTimestamp(new Date().toISOString())}
                                        style={{ borderRadius: "6px" }}
                                    />
                                </div>
                                <div className='mx-2'></div>
                                <div className="mb-3 w-50">
                                    <label className="form-label text-muted">Raised By</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        disabled
                                        value={verified_by}
                                        onChange={(e) => onVerifiedByChange(e.target.value)}
                                        style={{ borderRadius: "6px" }}
                                        placeholder="Enter your name"
                                    />
                                </div>
                            </div>

                            {remarks.map((remark, index) => (
                                <div className="mb-3" key={index}>
                                    <label className="form-label text-muted">Issue {index + 1}</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        value={remark}
                                        onChange={(e) => onRemarkChange(index, e.target.value)}
                                        style={{ borderRadius: "6px" }}
                                        placeholder="Describe your issue"
                                    />
                                </div>
                            ))}

                            <button
                                className="btn btn-outline-primary mb-3"
                                onClick={onAddIssue}
                                style={{ borderRadius: "6px" }}
                            >
                                + Add Issue
                            </button>
                        </div>

                        <div className="modal-footer border-0">
                            <button className="btn btn-light" onClick={onClose} style={{ borderRadius: "6px" }}>
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={onSubmit}
                                disabled={isSubmitDisabled}
                                style={{ borderRadius: "6px", background: "#193e6c", border: "none" }}
                            >
                                Raise Flag
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FlagModal;